import { FlexRow } from '@/components/common/Flex';
import { FlexProps } from '@chakra-ui/react';
import React, { FC } from 'react';
import { Paragraph } from './Typography';

export interface BannerProps extends FlexProps {
    children: React.ReactNode;
    icon?: React.ReactNode;
    button?: React.ReactNode;
}

const Banner: FC<BannerProps> = ({ icon, button, children, ...props }) => (
    <FlexRow
        alignItems="center"
        backgroundColor="gray.100"
        borderWidth={1}
        borderColor="border"
        borderRadius={6}
        px={4}
        py={4}
        {...props}
    >
        {icon && <FlexRow mr={4}>{icon}</FlexRow>}

        <FlexRow alignItems="center" grow={1}>
            <Paragraph>{children}</Paragraph>
        </FlexRow>

        {button && (
            <FlexRow ml={4} mr={2}>
                {button}
            </FlexRow>
        )}
    </FlexRow>
);

export default Banner;
